import { Button, ButtonColour, ButtonSize } from "@trussle/external-components";
import React from "react";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { redirect } from "../../../../helpers/redirect";
import { trackEvent } from "../../../../helpers/analytics";

import "../styles.scss";

type ICalculatorVariant = "StampDuty" | "Remortgage" | "Deposit" | "Affordability" | "LTV";
interface ICalculatorTabLayoutProps {
  variant: ICalculatorVariant;
  form: React.ReactNode;
  result: React.ReactNode;
  ctaHandler?: () => void;
  disclaimer?: React.ReactNode;
}

const Disclaimer = (
  <div className="calculator-panel-v2__disclaimer">
    You may have to pay an early repayment charge if you remortgage.
    <br />
    Your home could be repossessed if you don't keep up repayments on your mortgage.
    <br />
    This calculator is only an estimate of how much you may be able to borrow. Talk to a mortgage broker or lender to get a more accurate figure.
  </div>
);

export const CalculatorTabLayout: React.FC<ICalculatorTabLayoutProps> = ({
  variant,
  form,
  result,
  ctaHandler,
  disclaimer = Disclaimer
}) => {
  const isMobile = useIsMobile(960);

  const defaultCtaHandler = async () => {
    await redirect("https://better.co.uk/get-started");

    await trackEvent(`${variant} calculator cta clicked`, {
      module: `${variant} calculator`
    });
  };

  return (
    <div className="calculator-content">
      <div className="calculator-panel-v2__form">
        { form }
        {!isMobile && disclaimer}
      </div>
      <div
        className={
          isMobile
            ? "calculator-panel-v2-breaker__horizontal"
            : "calculator-panel-v2-breaker__vertical"
        }
      />
      <div className="calculator-panel-v2__result">
        { result }
        <Button
          colour={ButtonColour.Black}
          size={ButtonSize.Large}
          onClick={ctaHandler || defaultCtaHandler}
        >
          Get Started
        </Button>
      </div>
      {isMobile && disclaimer}
    </div>
  );
};
